import {
  Button,
  Input,
} from "@wac-ui-dashboard/wac_component_library";
import Select from "react-select";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import Style from "../../CustomOffers/CreateOffer/createOffer.module.scss";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import useAddPopularSearch from "./useAddPopularSearch";

const AddPopularSearch = ({ isStickyFooter, handleCreateClick, refetch }) => {
  const {
    formik,
    isEdit,
    basicData,
    isLoading,
    handleTypeChange,
    getFieldError,
    closeModal,
  } = useAddPopularSearch(handleCreateClick, refetch);

  return (
    <div className="row">
      <div className="input-wrap pro-mb-4">
        <Input
          label={"Search Text"}
          type="text"
          id="search_text"
          name="search_text"
          className={`pro-input lg ${getFieldError("search_text") && " error"}`}
          {...formik.getFieldProps("search_text")}
          error={getFieldError("search_text")}
          errorMessage={getFieldError("search_text")}
        />
        <div className="pro-rtl">
          <Input
            label={"(عنوان)Search Text"}
            type="text"
            id="alias_search_text"
            name="alias_search_text"
            className={`pro-input lg ${
              getFieldError("alias_search_text") && " error"
            }`}
            {...formik.getFieldProps("alias_search_text")}
            error={getFieldError("alias_search_text")}
            errorMessage={getFieldError("alias_search_text")}
          />
        </div>

        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Type
          </label>
          <Select
            id="search_type"
            name="search_type"
            placeholder={"Select"}
            className={`pro-input lg  ${
              getFieldError("search_type") && " error"
            }`}
            classNamePrefix="pro-input"
            options={basicData?.data?.type_list ?? []}
            value={formik?.values?.search_type ?? {}}
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            onBlur={formik.handleBlur("search_type")}
            onChange={(e) => handleTypeChange(e)}
            menuPlacement="auto"
          />
          {getFieldError("search_type") && (
            <span className="error-text">{getFieldError("search_type")}</span>
          )}
        </div>
        {formik.values.search_type?.id === 2 && (
          <div className={`pro-mb-4 ${Style.time_wrap}`}>
          <div className={`pro-d-flex  ${Style.time_picker_wrap}`}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <div className={`${Style.time_item}`}>
                <label
                  htmlFor=""
                  className="pro-font-sm pro-mb-1 pro-fw-medium"
                >
                  Start Time
                </label>
                <TimePicker
                  value={formik.values.start_time || null}
                  onChange={(newValue) => {
                    formik.setFieldValue("start_time", newValue);
                  }}
                  className="time-picker"
                />
                {getFieldError("start_time") && (
                  <span className="error-custom">
                    {getFieldError("start_time")}
                  </span>
                )}
              </div>

              <div className={`${Style.spacer_icon}`}>
                <span className="pro-px-3 pro-d-flex pro-items-center">
                  <span className="material-symbols-outlined x4">remove</span>
                </span>
              </div>
              <div className={`${Style.time_item}`}>
                <label
                  htmlFor=""
                  className="pro-font-sm pro-mb-1 pro-fw-medium"
                >
                 End Time
                </label>
                <TimePicker
                  value={formik.values.end_time || null}
                  onChange={(newValue) => {
                    formik.setFieldValue("end_time", newValue);
                  }}
                  className="time-picker"
                  disabled={!formik.values.start_time}
                />
                {getFieldError("end_time") && (
                  <span className="error-custom">
                    {getFieldError("end_time")}
                  </span>
                )}
              </div>
            </LocalizationProvider>
          </div>
        </div>
        )}

        <div className="pro-check-box pro-py-2">
          <div className="form-check form-switch ">
            <input
              className="form-check-input cursor-pointer"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              checked={Boolean(formik.values?.status === 1) ?? false}
              onChange={(e) =>
                formik.setFieldValue(`status`, e?.target?.checked ? 1 : 2)
              }
            />
            <label htmlFor="default" className="pro-check-label">
              Status
            </label>
          </div>
        </div>
        <div
          className={`col-12 pro-d-flex pro-justify-end ${
            isStickyFooter && "offcanvas-footer-sticky-btns"
          }`}
        >
          <Button
            className={"pro-btn-link lg pro-px-5"}
            onClick={() => closeModal()}
          >
            Cancel
          </Button>

          <Button
            className={`pro-btn-primary lg pro-ms-3 ${false ? "loading" : ""}`}
            type="submit"
            disabled={isLoading}
            onClick={formik.handleSubmit}
          >
            {!isEdit
              ? isLoading
                ? "Creating..."
                : "Create"
              : isLoading
              ? "Updating..."
              : "Update"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddPopularSearch;
